// extracted by mini-css-extract-plugin
module.exports = {"headerBackground":"HeaderBackground_headerBackground__qarag","opacity":"HeaderBackground_opacity__KFdun"};